import { NavigationItem } from './navigationItem';
import { SelectClickableCollection } from '../selection';
import { SelectClickableCollectionOptions } from '../../interfaces/options';

export class Navigation extends SelectClickableCollection<NavigationItem> {
	constructor(options: SelectClickableCollectionOptions<NavigationItem>) {
		super(options);
	}
}
